import status from './status'

const auditProcess = {
  status,
}

export default auditProcess
